import { render, staticRenderFns } from "./Category_news.vue?vue&type=template&id=6418ec12&scoped=true"
import script from "./Category_news.vue?vue&type=script&lang=js"
export * from "./Category_news.vue?vue&type=script&lang=js"
import style0 from "./Category_news.vue?vue&type=style&index=0&id=6418ec12&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6418ec12",
  null
  
)

export default component.exports